// hi — checkin/quickCheck/stepTracker blocks translated.
export const hi = {
  "common": {
    "loading": "लोड हो रहा है…",
    "save": "सहेजें",
    "cancel": "रद्द करें",
    "delete": "हटाएँ",
    "edit": "संपादित करें",
    "close": "बंद करें",
    "confirm": "पुष्टि करें",
    "back": "वापस",
    "next": "आगे",
    "submit": "जमा करें",
    "search": "खोजें",
    "select": "चुनें",
    "or": "या",
    "and": "और",
    "note": "टिप्पणी",
    "viewAll": "सभी देखें",
    "learnMore": "और जानें",
    "getStarted": "शुरू करें",
    "continue": "जारी रखें",
    "saving": "सहेजा जा रहा है…"
  },
  "offline": {
    "banner": "आप ऑफ़लाइन हैं। कुछ सुविधाएँ सीमित हो सकती हैं।",
    "savedLocally": "ऑफ़लाइन सहेजा गया — ऑनलाइन होने पर सिंक होगा",
    "syncing": "आपके अपडेट सिंक हो रहे हैं…",
    "backOnline": "वापस ऑनलाइन — अपडेट सिंक हो गए"
  },

  "nav": {
    "dashboard": "डैशबोर्ड",
    "nutrition": "स्मार्ट पोषण",
    "family": "परिवार",
    "care": "सेवाएँ",
    "careShort": "सेवाएँ",
    "checkIn": "दैनिक चेक-इन",
    "insights": "इनसाइट्स",
    "trends": "रुझान",
    "habits": "आदतें",
    "medications": "दवाएँ",
    "expertSupport": "विशेषज्ञ सहायता",
    "profile": "प्रोफ़ाइल",
    "healthHub": "स्वास्थ्य हब",
    "support": "सहायता",
    "wellness": "कल्याण",
    "education": "शिक्षा",
    "community": "समुदाय",
    "preventiveHealth": "निवारक स्वास्थ्य",
    "womensHealth": "महिला स्वास्थ्य",
    "reminders": "याद दिलाने वाले",
    "meals": "भोजन",
    "orders": "ऑर्डर",
    "subscription": "सदस्यता",
    "logout": "लॉग आउट"
  },

  "navShort": {
    "dashboard": "होम",
    "nutrition": "पोषण",
    "family": "परिवार",
    "care": "सेवाएँ",
    "support": "सहायता",
    "profile": "प्रोफ़ाइल"
  },
  "auth": {
    "login": "साइन इन",
    "register": "खाता बनाएँ",
    "logout": "साइन आउट",
    "email": "ईमेल",
    "password": "पासवर्ड",
    "name": "पूरा नाम",
    "forgotPassword": "पासवर्ड भूल गए?",
    "noAccount": "खाता नहीं है?",
    "haveAccount": "Already have an account?",
    "signInHere": "Sign in here",
    "signUpHere": "Sign up here",
    "welcomeBack": "वापसी पर स्वागत है!",
    "getStarted": "शुरू करें",
    "biometricLogin": "Sign in with Biometrics",
    "biometricHelper": "Use fingerprint, Face ID, or Windows Hello",
    "vendorLogin": "Vendor Login",
    "createOne": "खाता बनाएँ",
    "tagline": "अपने स्वास्थ्य का ख़्याल रखें — हर दिन एक छोटा-सा चेक-इन।",
    "takes30s": "30 सेकंड से कम",
    "emailPlaceholder": "aap@example.com",
    "passwordPlaceholder": "अपना पासवर्ड डालें",
    "checking": "जाँच रहा है…",
    "continue": "जारी रखें",
    "secureMessage": "सुरक्षित और निजी — आपका डेटा सुरक्षित है",
    "biometricSoon": "बायोमेट्रिक लॉगिन — जल्द आ रहा है",
    "showPassword": "पासवर्ड दिखाएं",
    "hidePassword": "पासवर्ड छिपाएं",
    "vendor": {
      "title": "वेंडर पार्टनर लॉगिन",
      "subtitle": "अपने HealthLoop वेंडर डैशबोर्ड तक पहुंचें",
      "businessEmail": "व्यावसायिक ईमेल",
      "emailPlaceholder": "vendor@business.com",
      "passwordPlaceholder": "••••••••",
      "signingIn": "लॉगिन हो रहा है...",
      "signIn": "लॉगिन करें",
      "notVendorYet": "अभी तक वेंडर पार्टनर नहीं हैं?",
      "registerBusiness": "अपना व्यवसाय रजिस्टर करें",
      "areYouUser": "क्या आप यूजर हैं?",
      "userLogin": "यूजर लॉगिन",
      "welcomeBackToast": "आपका स्वागत है!",
      "genericError": "लॉगिन विफल रहा। कृपया पुनः प्रयास करें।"
    },
    "admin": {
      "backToUserLogin": "यूजर लॉगिन",
      "title": "एडमिन लॉगिन",
      "restrictedBadge": "प्रतिबंधित",
      "tagline": "HealthLoop ऑपरेटर कंसोल — एडमिन क्रेडेंशियल आवश्यक हैं।",
      "emailLabel": "एडमिन ईमेल",
      "emailPlaceholder": "admin@yourdomain.com",
      "passwordLabel": "पासवर्ड",
      "passwordPlaceholder": "अपना एडमिन पासवर्ड दर्ज करें",
      "signingIn": "लॉगिन हो रहा है…",
      "submit": "एडमिन कंसोल में लॉगिन करें",
      "secureNote": "सुरक्षित कनेक्शन · सत्र एन्क्रिप्टेड है",
      "restrictedTitle": "यह क्षेत्र केवल एडमिन के लिए है।",
      "restrictedBody": "आपने लॉगिन तो कर लिया है, लेकिन आपके पास एडमिन एक्सेस नहीं है। किसी अन्य खाते से प्रयास करने के लिए साइन आउट करें, या मुख्य ऐप पर वापस जाएं।",
      "signOut": "साइन आउट",
      "backToApp": "ऐप पर वापस जाएं"
    }
  },
  "quickCheck": {
    "header": {
      "title": "आज आप कैसा महसूस कर रहे हैं?",
      "subtitle": "त्वरित जांच — इसमें 60 सेकंड से भी कम समय लगता है"
    },
    "section1": {
      "title": "आज आप क्या नोटिस कर रहे हैं?",
      "hint": "(जो भी लागू हो उन्हें चुनें)"
    },
    "environment": {
      "title": "आज आपका वातावरण",
      "hint": "हमें अपने आस-पास के माहौल को समझने में मदद करें"
    },
    "basicChecks": {
      "title": "त्वरित बुनियादी जांच",
      "hint": "वैकल्पिक लेकिन मददगार"
    },
    "validation": {
      "pickOne": "कृपया कम से कम एक प्रश्न का उत्तर दें"
    },
    "submit": {
      "cta": "मेरी हेल्थ इनसाइट प्राप्त करें",
      "saving": "सेव हो रहा है...",
      "analyzing": "आपके स्वास्थ्य पैटर्न का विश्लेषण किया जा रहा है...",
      "savedToast": "✅ चेक-इन सेव हो गया! आपके स्वास्थ्य पैटर्न का विश्लेषण किया जा रहा है..."
    }
  },
  "stepTracker": {
    "header": {
      "title": "स्टेप ट्रैकर",
      "subtitle": "आपकी गतिविधि पर एक ईमानदार नज़र",
      "backToDashboard": "डैशबोर्ड पर वापस जाएं"
    },
    "today": {
      "title": "आज के कदम",
      "goalProgress": "{{current}} / {{goal}} कदम",
      "goalReached": "लक्ष्य पूरा हुआ — शानदार काम!",
      "keepGoing": "चलते रहें — आप सही रास्ते पर हैं।"
    },
    "streak": {
      "label": "वर्तमान सिलसिला",
      "days": "{{count}} दिन",
      "daysPlural": "{{count}} दिन"
    },
    "badges": {
      "title": "बैज",
      "empty": "जैसे-जैसे आप आदत बनाएंगे, आप बैज जीतेंगे।"
    },
    "reminders": {
      "title": "मूवमेंट अलर्ट",
      "hint": "लंबे समय तक बैठने के दौरान थोड़ी देर चलने के लिए कोमल याद दिलाना।",
      "enabled": "चालू",
      "disabled": "बंद"
    },
    "insights": {
      "weeklyAverage": "साप्ताहिक औसत",
      "weeklyGoal": "साप्ताहिक लक्ष्य"
    },
    "actions": {
      "connect": "स्टेप सोर्स से कनेक्ट करें",
      "manualLog": "कदमों को खुद दर्ज करें",
      "changeGoal": "दैनिक लक्ष्य बदलें"
    },
    "offline": {
      "title": "ऑफ़लाइन मोड सक्रिय",
      "body": "ऑफ़लाइन रहते हुए भी ट्रैकिंग जारी रहती है। दोबारा कनेक्ट होने पर हम आपके अपडेट सिंक कर देंगे।"
    },
    "permission": {
      "title": "स्वचालित स्टेप ट्रैकिंग के लिए कनेक्ट करें",
      "body": "HealthLoop को आपका {{platform}} डेटा पढ़ने की अनुमति दें। जब तक आप सिंक नहीं करते, आपका वेलनेस डेटा आपके डिवाइस पर ही रहता है।",
      "connect": "कनेक्ट करें",
      "maybeLater": "बाद में"
    },
    "sync": {
      "lastSynced": "अंतिम सिंक {{time}}",
      "queued": "{{count}} अपडेट सिंक के लिए कतार में।",
      "queuedPlural": "{{count}} अपडेट सिंक के लिए कतार में।",
      "disconnect": "डिस्कनेक्ट करें",
      "refreshAria": "सिंक रीफ्रेश करें"
    },
    "progress": {
      "title": "आज की प्रगति",
      "stepsToday": "आज के स्टेप्स",
      "goalLabel": "लक्ष्य: {{goal}}",
      "stepsToGo": "{{remaining}} स्टेप्स बाकी",
      "goalAchieved": "🎉 लक्ष्य पूरा हुआ",
      "goalAriaLabel": "लक्ष्य प्राप्त",
      "statGoal": "लक्ष्य",
      "statProgress": "प्रगति",
      "statSource": "स्रोत",
      "sourceDevice": "डिवाइस",
      "sourceManual": "मैनुअल"
    },
    "empty": {
      "waiting": "गतिविधि डेटा का इंतज़ार",
      "startMoving": "ट्रैकिंग शुरू करने के लिए चलना शुरू करें",
      "shortWalkHint": "ट्रैकिंग जांचने के लिए थोड़ा टहलें — या नीचे मैनुअल एंट्री दर्ज करें।"
    },
    "manual": {
      "title": "मैन्युअल स्टेप्स दर्ज करें",
      "placeholder": "स्टेप्स दर्ज करें",
      "submit": "दर्ज करें",
      "footer": "मैन्युअल एंट्री आज के काउंट को बदल देती हैं। ऑनलाइन होने पर वे अपने आप सिंक हो जाती हैं।"
    },
    "trust": {
      "title": "डिफ़ॉल्ट रूप से निजी",
      "itemData": "आपका वेलनेस डेटा आपके डिवाइस पर रहता है जब तक आप अकाउंट से सिंक नहीं करते।",
      "itemOffline": "ऑफ़लाइन रहते हुए भी ट्रैकिंग जारी रहती है — अपडेट कतार में रहते हैं और दोबारा कनेक्ट होने पर सिंक हो जाते हैं।",
      "itemNoInvent": "हम कभी स्टेप काउंट नहीं बनाते। केवल आपके डिवाइस या मैनुअल एंट्री के मान ही संग्रहीत होते हैं।"
    },
    "howItWorks": {
      "title": "यह कैसे काम करता है",
      "itemConnect": "हैंड्स-फ्री ट्रैकिंग के लिए अपने डिवाइस के हेल्थ ऐप से कनेक्ट करें।",
      "itemManual": "विश्वसनीय फॉलबैक के रूप में मैन्युअल एंट्री हमेशा उपलब्ध रहती है।",
      "itemOfflineQueue": "ऑफ़लाइन अपडेट स्थानीय रूप से कतार में रहते हैं और ऑनलाइन वापस आते ही सिंक हो जाते हैं।",
      "itemDisconnect": "जब चाहें डिस्कनेक्ट करें — आपका लॉग किया गया इतिहास इस डिवाइस पर बना रहेगा।"
    }
  },
  "checkin": {
    "header": {
      "title": "डेली हेल्थ चेक-इन",
      "subtitle": "इसमें 60 सेकंड से भी कम समय लगता है",
      "restDayLink": "आज मेरी इच्छा नहीं है"
    },
    "snapshot": {
      "title": "आपका डैशबोर्ड, अपडेट हो गया है",
      "healthScore": "हेल्थ स्कोर",
      "todayTasks": "आज के कार्य",
      "dayStreak": "दिनों का सिलसिला"
    },
    "resume": {
      "banner": "वहीं से शुरू करें जहाँ आपने छोड़ा था",
      "startFresh": "नए सिरे से शुरू करें",
      "dismiss": "हटाएं"
    },
    "progress": {
      "allSet": "सब तैयार है",
      "step": "चरण {{current}} / {{total}}",
      "ariaLabel": "डेली चेक-इन प्रगति: {{done}} में से {{total}} सेक्शन पूरे हुए"
    },
    "insights": {
      "title": "आपकी हेल्थ इनसाइट्स",
      "subtitle": "आज खास आपके लिए तैयार की गई",
      "insightForYou": "आपके लिए जानकारी",
      "simpleActions": "आसान कदम जो आप उठा सकते हैं",
      "whenToSeekHelp": "मदद कब लें",
      "nhsAdvice": "यदि चिंतित हैं, तो अपने डॉक्टर या स्वास्थ्य सलाहकार से संपर्क करें",
      "backToDashboard": "डैशबोर्ड पर वापस जाएं",
      "newCheckIn": "नया चेक-इन",
      "disclaimer": "HealthLoop केवल मार्गदर्शन प्रदान करता है, स्वास्थ्य संबंधी जांच (मेडिकल डायग्नोसिस) नहीं।"
    },
    "restDay": {
      "title": "आराम भी जीवन की लय का हिस्सा है।",
      "body": "जब आप तैयार होंगे, हम कल यहीं मिलेंगे।",
      "streakNote": "आपका सिलसिला थमा नहीं है — वह भी बस आराम कर रहा है।",
      "backToDashboard": "डैशबोर्ड पर वापस जाएं",
      "changedMind": "दरअसल, मैं चेक-इन करना चाहता हूँ।"
    },
    "feelings": {
      "title": "आज आप कैसा महसूस कर रहे हैं?",
      "hint": "जो भी लागू हो उन्हें चुनें",
      "tired": "थकान महसूस होना",
      "headache": "सिरदर्द",
      "stressed": "तनाव या घबराहट",
      "pain": "बदन दर्द या पीड़ा",
      "okay": "मैं आज ठीक महसूस कर रहा हूँ"
    },
    "basics": {
      "title": "आपकी बुनियादी बातें",
      "sleepQ": "क्या कल रात आपको अच्छी नींद आई?",
      "waterQ": "क्या आज आपने पर्याप्त पानी पिया?",
      "foodQ": "क्या आज आपने ठीक से खाना खाया?",
      "activityQ": "आज आप कितने सक्रिय थे?",
      "yes": "हाँ",
      "notReally": "खास नहीं",
      "notYet": "अभी नहीं",
      "notActive": "सक्रिय नहीं",
      "lightActivity": "हल्की गतिविधि",
      "active": "सक्रिय"
    },
    "mind": {
      "title": "मन और ऊर्जा",
      "stressQ": "आज आपका तनाव का स्तर कैसा है?",
      "moodQ": "आज आपका मूड कैसा है?",
      "energyQ": "आज आपकी ऊर्जा का स्तर कैसा है?",
      "low": "कम",
      "moderate": "सामान्य",
      "high": "ज्यादा",
      "neutral": "ठीक-ठाक",
      "good": "अच्छा",
      "okay": "सही है"
    },
    "day": {
      "title": "आपका दिन",
      "routineQ": "क्या आज आपने अपनी सामान्य दिनचर्या का पालन किया?",
      "yes": "हाँ",
      "no": "नहीं"
    },
    "environment": {
      "title": "आज आपका वातावरण",
      "describeQ": "आप अपने आस-पास के माहौल को कैसे बताएंगे?",
      "comfortable": "😊 आरामदायक",
      "slightlyUncomfortable": "😐 थोड़ा असहज",
      "challenging": "😓 चुनौतीपूर्ण",
      "affectedQ": "क्या आपके परिवेश ने आपके महसूस करने के तरीके को प्रभावित किया?",
      "yes": "हाँ",
      "no": "नहीं",
      "exposureLabel": "संपर्क (जो भी लागू हो चुनें)",
      "heat": "🌡️ गर्मी",
      "cold": "❄️ ठंड",
      "noise": "🔊 शोर",
      "dustSmoke": "💨 धूल या धुआं",
      "crowded": "👥 भीड़भाड़ वाली जगह",
      "none": "✅ कोई नहीं"
    },
    "submit": {
      "analyzing": "आपके स्वास्थ्य के पैटर्न का विश्लेषण किया जा रहा है...",
      "cta": "मेरी हेल्थ इनसाइट्स देखें"
    },
    "toast": {
      "savedFull": "चेक-इन सेव हो गया! आपका डैशबोर्ड अपडेट कर दिया गया है।",
      "savedShort": "चेक-इन सेव हो गया।"
    }
  },
  "onboarding": {
    "welcome": "Welcome",
    "completeSetup": "Complete Setup",
    "stepProgress": "Step {{step}} of {{total}}",
    "percentComplete": "{{percent}}% complete",
    "welcomeToast": "Welcome to HealthLoop! Your profile is set up.",
    "errorAgeRange": "Please select your age range",
    "errorCountry": "Please select your country",
    "errorGoal": "Please select your primary health goal",
    "errorCuisine": "Please select at least one cuisine preference",
    "errorGeneric": "Failed to complete onboarding. Please try again.",
    "step1Title": "Welcome to HealthLoop! 👋",
    "step1Subtitle": "Let's personalize your health journey",
    "ageRangeLabel": "What's your age range?",
    "genderLabel": "Gender (Optional)",
    "gender_male": "Male",
    "gender_female": "Female",
    "gender_non-binary": "Non-binary",
    "gender_prefer_not_to_say": "Prefer not to say",
    "step2Title": "Where are you based? 🌍",
    "step2Subtitle": "This helps us recommend culturally relevant meals",
    "countryLabel": "Select your country",
    "country_uk": "United Kingdom",
    "country_nigeria": "Nigeria",
    "country_ghana": "Ghana",
    "country_kenya": "Kenya",
    "country_south_africa": "South Africa",
    "country_usa": "United States",
    "country_canada": "Canada",
    "country_india": "India",
    "country_jamaica": "Jamaica",
    "country_other": "Other",
    "step3Title": "What's your main goal? 🎯",
    "step3Subtitle": "Choose your primary health objective",
    "additionalGoals": "Any other goals? (Optional)",
    "goal_weight_loss": "Weight Loss",
    "goalDesc_weight_loss": "Lose weight healthily",
    "goal_weight_maintenance": "Maintain Weight",
    "goalDesc_weight_maintenance": "Stay at current weight",
    "goal_muscle_gain": "Build Muscle",
    "goalDesc_muscle_gain": "Gain strength & muscle",
    "goal_general_wellness": "General Wellness",
    "goalDesc_general_wellness": "Overall health improvement",
    "goal_better_sleep": "Better Sleep",
    "goalDesc_better_sleep": "Improve sleep quality",
    "goal_reduce_stress": "Reduce Stress",
    "goalDesc_reduce_stress": "Manage stress better",
    "goal_increase_energy": "More Energy",
    "goalDesc_increase_energy": "Feel more energized",
    "step4Title": "Food preferences 🍽️",
    "step4Subtitle": "Select cuisines you enjoy and any dietary restrictions",
    "cuisineLabel": "Preferred Cuisines",
    "cuisineHint": "Select at least one (you can choose multiple)",
    "dietaryLabel": "Dietary Restrictions (Optional)",
    "diet_vegetarian": "Vegetarian",
    "diet_vegan": "Vegan",
    "diet_halal": "Halal",
    "diet_kosher": "Kosher",
    "diet_gluten_free": "Gluten-Free",
    "diet_dairy_free": "Dairy-Free",
    "diet_pescatarian": "Pescatarian",
    "step5Title": "Health conditions 🏥",
    "step5Subtitle": "Optional — helps us provide better recommendations",
    "conditionsLabel": "Do you have any of these conditions?",
    "conditionsHint": "This information is private and helps personalize your experience",
    "condition_diabetes": "Diabetes",
    "condition_hypertension": "High Blood Pressure",
    "condition_heart_disease": "Heart Disease",
    "condition_thyroid": "Thyroid Issues",
    "condition_celiac": "Celiac Disease",
    "condition_ibs": "IBS",
    "condition_none": "None",
    "privacyTitle": "Your data is protected",
    "privacyBody": "Your personal information is encrypted and stored securely. We use this data only to personalise your experience with tailored meal recommendations, health tips, and notifications. Your data will never be shared with third parties without your explicit consent.",
    "trackMedication": "I want to track my medications",
    "specialistInterest": "I'm interested in specialist consultations",
    "welcomeTitle": "HealthLoop में आपका स्वागत है! 👋",
    "welcomeSubtitle": "आइए, कुछ आसान चरणों में आपकी AI-आधारित प्रिवेंटिव हेल्थ और लाइफस्टाइल इंटेलिजेंस को बेहतर बनाएं",
    "stepLabel": "चरण {{current}} / {{total}}",
    "skipForNow": "अभी छोड़ें",
    "skipToast": "आप अपनी प्रोफ़ाइल से कभी भी ऑनबोर्डिंग पूरी कर सकते हैं",
    "back": "पीछे",
    "next": "आगे",
    "completing": "पूरा किया जा रहा है...",
    "complete": "सेटअप पूरा करें",
    "successToast": "HealthLoop में आपका स्वागत है! आपकी प्रोफ़ाइल अब तैयार है 🎉",
    "failureToast": "ऑनबोर्डिंग पूरी करने में विफल",
    "validation": {
      "basicInfo": "कृपया सभी बुनियादी जानकारी भरें",
      "pickGoal": "कृपया कम से कम एक स्वास्थ्य लक्ष्य चुनें",
      "pickPrimary": "कृपया अपना मुख्य लक्ष्य चुनें",
      "pickRegion": "व्यक्तिगत भोजन सुझावों के लिए कृपया अपना सांस्कृतिक क्षेत्र चुनें",
      "pickFocus": "कृपया अपना मुख्य वेलनेस फोकस चुनें"
    },
    "step1": {
      "title": "आपकी हेल्थ प्रोफ़ाइल",
      "description": "आपकी व्यक्तिगत AI हेल्थ इंटेलिजेंस बनाने में हमारी मदद करें",
      "age": "उम्र *",
      "agePlaceholder": "जैसे, 30",
      "height": "लंबाई (सेमी) *",
      "heightPlaceholder": "जैसे, 170",
      "weight": "वजन (किलो) *",
      "weightPlaceholder": "जैसे, 70"
    },
    "step2": {
      "title": "आपके स्वास्थ्य लक्ष्य",
      "description": "जो लागू हों उन्हें चुनें, फिर अपना मुख्य लक्ष्य चुनें",
      "primaryLabel": "अपना मुख्य लक्ष्य चुनें *",
      "primaryBadge": "मुख्य"
    },
    "step3": {
      "title": "🌍 सांस्कृतिक और भोजन प्राथमिकताएं",
      "description": "भोजन के सुझावों को आपके अनुसार बनाने में हमारी मदद करें",
      "regionLabel": "सांस्कृतिक क्षेत्र *",
      "regionHint": "व्यक्तिगत भोजन सुझावों के लिए अपनी सांस्कृतिक पृष्ठभूमि चुनें",
      "countryLabel": "देश (वैकल्पिक)",
      "countryPlaceholder": "जैसे, भारत, केन्या, जमैका",
      "countryHint": "बेहतर और सटीक सुझावों के लिए",
      "foodPrefLabel": "भोजन विविधता प्राथमिकता"
    },
    "step4": {
      "title": "मुख्य वेलनेस फोकस",
      "description": "वह क्षेत्र चुनें जिस पर आप सबसे अधिक ध्यान देना चाहते हैं"
    },
    "step5": {
      "title": "आपकी प्राथमिकताएं",
      "description": "अपने HealthLoop अनुभव को अनुकूलित करें",
      "trackMeds": "दवाओं को ट्रैक करें",
      "trackMedsHint": "अपने दैनिक चेक-इन में दवा ट्रैकिंग और रिमाइंडर चालू करें",
      "specialist": "विशेषज्ञ सहायता में रुचि",
      "specialistHint": "वेलनेस विशेषज्ञों, पोषण विशेषज्ञों और मानसिक स्वास्थ्य पेशेवरों तक पहुंच प्राप्त करें",
      "confidentialTitle": "गोपनीय सहायता:",
      "confidentialBody": "आपकी सभी जानकारी सुरक्षित है और इसका उपयोग केवल व्यक्तिगत प्रिवेंटिव हेल्थ इनसाइट्स प्रदान करने के लिए किया जाता है।"
    },
    "step6": {
      "title": "भोजन का निजीकरण",
      "description": "आपकी पसंद और आहार संबंधी जरूरतों के अनुसार भोजन सुझाने में हमारी मदद करें",
      "cuisinesLabel": "पसंदीदा व्यंजन (वैकल्पिक)",
      "cuisinesHint": "वे व्यंजन चुनें जिन्हें आप सबसे अधिक पसंद करते हैं",
      "dietaryLabel": "आहार संबंधी प्रतिबंध (वैकल्पिक)",
      "dietaryHint": "जो आप पर लागू हों उन्हें चुनें",
      "allergiesLabel": "सामान्य एलर्जी (वैकल्पिक)",
      "allergiesHint": "खाद्य एलर्जी का चयन करें",
      "personalisedTitle": "व्यक्तिगत भोजन:",
      "personalisedBody": "हम इन प्राथमिकताओं का उपयोग आपकी पसंद के अनुसार भोजन सुझाने के लिए करेंगे। आप इन्हें बाद में सेटिंग्स में अपडेट कर सकते हैं।"
    },
    "healthGoals": {
      "better_sleep": "बेहतर नींद",
      "reduce_stress": "तनाव कम करें",
      "increase_energy": "ऊर्जा बढ़ाएं",
      "weight_management": "वजन प्रबंधन",
      "improve_fitness": "फिटनेस सुधारें",
      "better_nutrition": "बेहतर पोषण",
      "mental_wellness": "मानसिक स्वास्थ्य",
      "chronic_condition": "क्रोनिक कंडीशन मैनेज करें"
    },
    "wellnessFocus": {
      "mental_health": {
        "label": "मानसिक स्वास्थ्य",
        "description": "मूड, तनाव और भावनात्मक स्वास्थ्य पर ध्यान दें"
      },
      "physical_fitness": {
        "label": "शारीरिक फिटनेस",
        "description": "व्यायाम, शक्ति और गतिविधि पर ध्यान दें"
      },
      "nutrition": {
        "label": "पोषण",
        "description": "आहार, भोजन और स्वस्थ खान-पान पर ध्यान दें"
      },
      "sleep": {
        "label": "नींद की गुणवत्ता",
        "description": "विश्राम, नींद के पैटर्न और रिकवरी पर ध्यान दें"
      },
      "stress_management": {
        "label": "तनाव प्रबंधन",
        "description": "आराम और तनाव कम करने पर ध्यान दें"
      }
    },
    "culturalRegions": {
      "west_african": {
        "label": "पश्चिम अफ्रीकी",
        "description": "नाइजीरियाई, घानायन, सेनेगली व्यंजन"
      },
      "east_african": {
        "label": "पूर्वी अफ्रीकी",
        "description": "केन्याई, इथियोपियाई, तंजानियाई व्यंजन"
      },
      "north_african": {
        "label": "उत्तरी अफ्रीकी",
        "description": "मोरक्कन, मिस्र के व्यंजन"
      },
      "southern_african": {
        "label": "दक्षिणी अफ्रीकी",
        "description": "दक्षिण अफ्रीकी व्यंजन"
      },
      "caribbean": {
        "label": "कैरेबियन",
        "description": "जमैकन, त्रिनिदादियन, बारबाडियन व्यंजन"
      },
      "middle_eastern": {
        "label": "मध्य पूर्वी",
        "description": "लेबनानी, फिलिस्तीनी, सीरियाई व्यंजन"
      },
      "south_asian": {
        "label": "दक्षिण एशियाई",
        "description": "भारतीय, पाकिस्तानी, बांग्लादेशी व्यंजन"
      },
      "east_asian": {
        "label": "पूर्वी एशियाई",
        "description": "चीनी, जापानी, कोरियाई व्यंजन"
      },
      "southeast_asian": {
        "label": "दक्षिण पूर्व एशियाई",
        "description": "थाई, वियतनामी, इंडोनेशियाई व्यंजन"
      },
      "western": {
        "label": "पश्चिमी",
        "description": "अमेरिकी, यूरोपीय व्यंजन"
      },
      "latin_american": {
        "label": "लैटिन अमेरिकी",
        "description": "मैक्सिकन, ब्राजीलियाई, अर्जेंटीना व्यंजन"
      },
      "mediterranean": {
        "label": "भूमध्यसागरीय",
        "description": "ग्रीक, इतालवी, स्पेनिश व्यंजन"
      }
    },
    "foodPreferences": {
      "traditional": {
        "label": "पारंपरिक",
        "description": "ज्यादातर आपके सांस्कृतिक क्षेत्र के व्यंजन"
      },
      "mixed": {
        "label": "मिश्रित",
        "description": "स्थानीय और अंतरराष्ट्रीय व्यंजनों का संतुलन"
      },
      "international": {
        "label": "अंतरराष्ट्रीय",
        "description": "विविध वैश्विक व्यंजन"
      }
    },
    "cuisines": {
      "west_african": "पश्चिम अफ्रीकी",
      "caribbean": "कैरेबियन",
      "mediterranean": "भूमध्यसागरीय",
      "asian": "एशियाई",
      "western": "पश्चिमी",
      "indian": "भारतीय",
      "middle_eastern": "मध्य पूर्वी",
      "general": "सभी व्यंजन"
    },
    "dietary": {
      "vegetarian": "शाकाहारी",
      "vegan": "वीगन",
      "pescatarian": "पेस्केटेरियन",
      "gluten_free": "ग्लूटेन-मुक्त",
      "dairy_free": "डेयरी-मुक्त",
      "low_carb": "लो-कार्ब"
    },
    "allergies": {
      "nuts": "मेवे (नट्स)",
      "shellfish": "शेलफिश",
      "dairy": "डेयरी",
      "eggs": "अंडे",
      "soy": "सोया",
      "gluten": "ग्लूटेन"
    },
    "cuisine_nigerian": "नाइजीरियाई",
    "cuisine_ghanaian": "घानाई",
    "cuisine_senegalese": "सेनेगाली",
    "cuisine_kenyan": "केन्याई",
    "cuisine_ethiopian": "इथियोपियाई",
    "cuisine_moroccan": "मोरक्कन",
    "cuisine_south_african": "दक्षिण अफ्रीकी",
    "cuisine_jamaican": "जमैकन",
    "cuisine_trinidadian": "त्रिनिडाडियन",
    "cuisine_lebanese": "लेबनानी",
    "cuisine_turkish": "तुर्की",
    "cuisine_greek": "यूनानी",
    "cuisine_italian": "इतालवी",
    "cuisine_french": "फ्रेंच",
    "cuisine_british": "ब्रिटिश",
    "cuisine_indian_south": "दक्षिण भारतीय",
    "cuisine_indian_north": "उत्तर भारतीय",
    "cuisine_pakistani": "पाकिस्तानी",
    "cuisine_japanese": "जापानी",
    "cuisine_chinese": "चीनी",
    "cuisine_korean": "कोरियाई",
    "cuisine_vietnamese": "वियतनामी",
    "cuisine_thai": "थाई",
    "cuisine_filipino": "फिलिपिनो",
    "cuisine_american": "अमेरिकी",
    "cuisine_mexican": "मैक्सिकन",
    "cuisine_brazilian": "ब्राजीली",
    "cuisine_peruvian": "पेरूवियन"
  },
  "dashboard": {
    "welcome": "वापसी पर स्वागत है",
    "greeting": "नमस्ते",
    "goodMorning": "सुप्रभात",
    "goodAfternoon": "नमस्कार",
    "goodEvening": "शुभ संध्या",
    "tagline": "छोटे स्वस्थ कदम लंबे बदलाव लाते हैं",
    "microcopy": "Your wellness journey matters.",
    "welcomeSubtitleMorning1": "A calm start to the day.",
    "welcomeSubtitleMorning2": "Glad you stopped by this morning.",
    "welcomeSubtitleMorning3": "Small moments add up.",
    "welcomeSubtitleAfternoon1": "Hope your day feels steady.",
    "welcomeSubtitleAfternoon2": "Welcome back to HealthLoop.",
    "welcomeSubtitleAfternoon3": "Take a breath — you're doing well.",
    "welcomeSubtitleEvening1": "Winding down with you.",
    "welcomeSubtitleEvening2": "A gentle close to the day.",
    "welcomeSubtitleEvening3": "Welcome back this evening.",
    "title": "Your Preventive Health Intelligence Platform",
    "subtitle": "Track, learn, and take action before problems escalate",
    "summary": "Your Health Intelligence Summary",
    "summaryDesc": "Real-time insights across prevention, education, engagement, and wellness",
    "comprehensiveSupport": "Comprehensive support across prevention, education, engagement, and wellness",
    "todayCheckIn": "आज का चेक-इन",
    "quickActions": "त्वरित क्रियाएँ",
    "healthOverview": "स्वास्थ्य अवलोकन",
    "recentActivity": "Recent Activity",
    "viewAll": "सभी देखें",
    "preventiveHealth": "Preventive Health",
    "preventiveHealthDesc": "Daily tracking, wellness monitoring & preventive alerts",
    "education": "Education",
    "educationDesc": "Evidence-based insights, health articles & expert guidance",
    "engagement": "Engagement",
    "engagementDesc": "Community challenges, habit tracking & social support",
    "wellness": "Wellness",
    "wellnessDesc": "Smart nutrition, lifestyle balance & holistic well-being",
    "todaysInsight": "आज की सीख",
    "wellnessScore": "कल्याण स्कोर",
    "healthStreak": "स्वास्थ्य लय",
    "days": "दिन",
    "logHealth": "Log Health",
    "getEducated": "Get Educated",
    "communityChallenge": "Community Challenge",
    "checkWellness": "Check Wellness",
    "verified": "Verified",
    "joinCommunity": "Join Community",
    "personalizedPlan": "Personalized Plan",
    "score": "Score",
    "checkIns": "check-ins",
    "habits": "habits",
    "preventive": "Preventive",
    "healthMetrics": "Health Metrics",
    "trackMetrics": "Track Metrics",
    "startTracking": "Start tracking",
    "logMetrics": "Log Metrics",
    "dailyInsight": "Daily Insight",
    "learnAbout": "Learn about preventive health today",
    "articlesAvailable": "articles available",
    "browseArticles": "Browse Articles",
    "currentStreak": "Current Streak",
    "keepGoing": "Keep it going!",
    "startStreak": "Start your streak",
    "checkIn": "चेक-इन",
    "nutritionPlan": "Nutrition Plan",
    "mealsPlanned": "meals planned",
    "viewPlan": "View Plan",
    "planYourWeek": "Plan your week",
    "moodStress": "मूड और तनाव",
    "howFeeling": "आप कैसा महसूस कर रहे हैं?",
    "logWellness": "Log Wellness",
    "medications": "दवाएँ",
    "noMeds": "No meds tracked",
    "addMedications": "Add your medications",
    "daysTracked": "Days Tracked",
    "noHabits": "No habits yet",
    "startTrackingHabits": "Start tracking habits",
    "insights": "Insights",
    "noInsights": "No insights yet",
    "completeFirstPlan": "Complete your first plan",
    "noCheckIns": "No check-ins yet",
    "startFirstCheckIn": "Start your first check-in"
  },
  "support": {
    "title": "सहायता",
    "subtitle": "उत्तर खोजें, हमसे संपर्क करें, या समस्या रिपोर्ट करें",
    "backToSettings": "सेटिंग्स पर वापस",
    "privacyBanner": "सहायता अनुरोध निजी रूप से संभाले जाते हैं। आपकी स्वास्थ्य जानकारी गोपनीय रहती है।",
    "section1": "Section 1",
    "section2": "Section 2",
    "section3": "Section 3",
    "section4": "Section 4",
    "navHelpCenter": "Help Center",
    "navContact": "Contact Support",
    "navHealth": "Health Services",
    "navTechnical": "Technical Support",
    "helpCenterTitle": "सहायता केंद्र",
    "helpCenterSubtitle": "Search common questions and find quick answers.",
    "contactTitle": "सहायता से संपर्क",
    "contactSubtitle": "Reach our team through your preferred channel.",
    "healthServicesTitle": "स्वास्थ्य सेवाएँ",
    "healthServicesSubtitle": "Connect with medication tracking and clinical experts.",
    "technicalTitle": "तकनीकी सहायता",
    "technicalSubtitle": "Report bugs or technical issues with detailed context.",
    "searchPlaceholder": "Search common questions…",
    "liveChat": "Live Chat",
    "emailUs": "Email Us",
    "callBack": "Schedule a callback",
    "sendMessage": "Send a message",
    "medicationTracking": "Medication tracking",
    "specialistAccess": "Specialist access",
    "videoConsultation": "Video consultation",
    "reportBug": "Report a bug",
    "yourName": "Your name",
    "yourEmail": "Your email",
    "subject": "Subject",
    "message": "Message",
    "phone": "Phone",
    "description": "Description",
    "submit": "Submit",
    "successTitle": "Message sent",
    "successDescription": "We'll reply within 24–48 hours.",
    "healthDisclaimer": "For medical emergencies, contact local emergency services. HealthLoop is not a substitute for professional medical care."
  },
  "nutrition": {
    "smartNutrition": "स्मार्ट पोषण",
    "basedOnGoal": "Based on your goal:",
    "personalizedData": "Personalized based on your recent health data",
    "evidenceBased": "Evidence-based nutrition as part of your preventive health plan",
    "todaysMealSuggestions": "Today's Meal Suggestions",
    "customize": "अनुकूलित करें",
    "breakfast": "नाश्ता",
    "lunch": "दोपहर का भोजन",
    "dinner": "रात का भोजन",
    "loadingBreakfast": "Loading breakfast...",
    "loadingLunch": "Loading lunch...",
    "loadingDinner": "Loading dinner...",
    "cal": "cal",
    "protein": "protein",
    "swapMeal": "भोजन बदलें",
    "healthyOptionsNearYou": "Healthy Options Near You",
    "enableLocation": "Enable location",
    "view": "देखें",
    "discoverOptions": "Discover healthy restaurants, grocery stores, and meal prep vendors near you",
    "cuisinesSelected": "cuisines selected",
    "cuisineSelected": "cuisine selected",
    "dietaryPrefs": "dietary prefs",
    "dietaryPref": "dietary pref",
    "customizeMeals": "Customize meals to match your cultural preferences and dietary needs",
    "subtitleAdaptive": "Culturally adaptive, personalized meal planning for your health goals",
    "hideFavorites": "Hide Favorites",
    "viewFavorites": "View Favorites",
    "customizeMealsLegacy": "Customize meals to match your cultural preferences and dietary needs",
    "viewFullPlan": "View Full Plan",
    "exploreRecipes": "Explore Recipes"
  },
  "location": {
    "permissionTitle": "Find healthy options near you",
    "permissionDesc": "Used to recommend restaurants, grocery stores, and meal prep vendors aligned with your health goals.",
    "howToEnable": "How to enable:",
    "step1": "Click the lock icon 🔒 in your browser's address bar",
    "step2": "Find \"Location\" permissions",
    "step3": "Change to \"Allow\"",
    "step4": "Refresh this page",
    "refreshPage": "Refresh Page",
    "allowLocation": "Allow Location",
    "notNow": "Not now",
    "denied": "Location access was blocked. To see nearby healthy options, you'll need to enable location permissions.",
    "unavailable": "Location information is currently unavailable. Please check your device settings.",
    "error": "Unable to access your location. Please try again or check browser settings.",
    "unsupported": "Your browser doesn't support location services. Try using a modern browser like Chrome, Firefox, or Safari.",
    "accessRequired": "Location Access Required"
  },
  "womensHealth": {
    "title": "Women's Health",
    "description": "Track your cycle, log symptoms, and get personalized wellness tips based on your cycle phase",
    "cycleTracking": "Cycle Tracking",
    "symptomLogging": "Symptom Logging",
    "phaseInsights": "Phase Insights",
    "logPeriod": "Log Period",
    "logSymptoms": "Log Symptoms",
    "insights": "Insights",
    "tips": "Health Tips",
    "overview": "Overview",
    "history": "History",
    "startTracking": "Start Tracking Your Cycle"
  },
  "profile": {
    "title": "प्रोफ़ाइल",
    "personalInfo": "व्यक्तिगत जानकारी",
    "healthProfile": "स्वास्थ्य प्रोफ़ाइल",
    "preferences": "प्राथमिकताएँ",
    "language": "भाषा",
    "selectLanguage": "Select Language",
    "notifications": "सूचनाएँ",
    "privacy": "गोपनीयता",
    "security": "सुरक्षा",
    "quickAccess": "Quick Access",
    "editProfile": "प्रोफ़ाइल संपादित करें",
    "viewStats": "View Stats",
    "backToDashboard": "डैशबोर्ड पर वापस",
    "womensHealthTitle": "Women's Health",
    "womensHealthDesc": "Cycle tracking, symptoms & wellness tips",
    "healthRemindersTitle": "Health Reminders",
    "healthRemindersDesc": "Manage your notifications",
    "manageRemindersDesc": "Manage your reminder preferences and notifications",
    "healthPatternAlerts": "Your Health Pattern Alerts",
    "supportHelp": "सहायता",
    "supportHelpDesc": "Get assistance, report issues, or browse FAQs",
    "admin": "Admin",
    "adminDesc": "View usage metrics and user behavior insights",
    "giveFeedback": "फ़ीडबैक दें",
    "giveFeedbackDesc": "Share your experience with HealthLoop",
    "reportProblem": "समस्या की रिपोर्ट करें",
    "reportProblemDesc": "Help us fix bugs and improve the app",
    "manageHealthInfo": "Manage your preventive health information for personalized insights",
    "basicInformation": "Basic Information",
    "fullName": "Full Name",
    "email": "Email",
    "dateOfBirth": "Date of Birth",
    "gender": "Gender",
    "height": "Height (cm)",
    "weight": "Weight (kg)",
    "medicalConditions": "Medical Conditions",
    "allergies": "Allergies",
    "personalHealth": "Personal Health",
    "addCondition": "Add a medical condition",
    "addAllergy": "Add an allergy",
    "saveChanges": "Save Changes",
    "saving": "Saving...",
    "privacyMessage": "Your health data is protected with confidential care standards"
  },
  "settings": {
    "title": "Settings",
    "general": "General",
    "account": "Account",
    "appearance": "Appearance",
    "languageSettings": "Language Settings",
    "changeLanguage": "Change Language",
    "languageNote": "कुछ नई भाषाएँ AI-अनुवादित हैं और मूल वक्ता समीक्षा की प्रतीक्षा में हैं।",
    "languageUpdated": "Language updated successfully",
    "starterBadge": "स्टार्टर",
    "starterBadgeTooltip": "मशीनी अनुवाद — स्थानीय विशेषज्ञ समीक्षा लंबित है।",
    "regions": {
      "global": "वैश्विक",
      "european": "यूरोपीय भाषाएं",
      "middleEastern": "मध्य पूर्वी भाषाएं",
      "asian": "एशियाई भाषाएं",
      "african": "अफ्रीकी भाषाएं"
    }
  },
  "search": {
    "triggerLabel": "HealthLoop में खोजें",
    "triggerHint": "जैसे \"कदम\", \"फार्मेसी\" या \"गर्भावस्था\"",
    "triggerAriaLabel": "ग्लोबल सर्च खोलें",
    "placeholder": "सुविधाएँ, ट्रैकर, सहायता खोजें...",
    "inputAriaLabel": "HealthLoop सुविधाएँ खोजें",
    "modalAriaLabel": "HealthLoop में खोजें",
    "close": "बंद करें",
    "clear": "साफ़ करें",
    "clearAriaLabel": "खोज साफ़ करें",
    "recentSearches": "हाल की खोजें",
    "tryFor": "इन्हें खोजने का प्रयास करें",
    "findFeatures": "सेकंडों में कोई भी सुविधा खोजें।",
    "searchAcross": "खोजें",
    "and": "और",
    "sections": {
      "home": "होम",
      "nutrition": "पोषण",
      "family": "परिवार",
      "services": "सेवाएं",
      "support": "सहायता",
      "profile": "प्रोफ़ाइल"
    },
    "noMatchesFor": "\"{{query}}\" के लिए कोई परिणाम नहीं मिला",
    "trySimpler": "कदम, पोषण या विशेषज्ञ जैसे सरल शब्दों का प्रयास करें।",
    "comingSoonBadge": "जल्द आ रहा है",
    "escToClose": "बंद करने के लिए",
    "resultSingular": "{{count}} परिणाम",
    "resultPlural": "{{count}} परिणाम",
    "searchAcrossApp": "पूरे ऐप में खोजें"
  },
  "familyMember": {
    "confirmRemove": "क्या {{name}} को पारिवारिक स्वास्थ्य ट्रैकिंग से हटाना चाहते हैं?",
    "removed": "{{name}} को परिवार से हटा दिया गया",
    "removeFailed": "सदस्य को हटाने में विफल",
    "viewDetails": "विवरण देखें",
    "edit": "संपादन",
    "remove": "हटाएं",
    "yearsSuffix": "वर्ष",
    "healthGoalsLabel": "स्वास्थ्य लक्ष्य:",
    "moreSuffix": "अधिक",
    "activeInsights": "सक्रिय इनसाइट्स",
    "viewAllInsights": "सभी {{count}} इनसाइट्स देखें →",
    "viewFullProfile": "पूरा हेल्थ प्रोफ़ाइल देखें",
    "lifeStage": {
      "infant": "शिशु (0-2)",
      "toddler": "छोटा बच्चा (2-5)",
      "child": "बच्चा (6-12)",
      "adolescent": "किशोर (13-17)",
      "adult": "वयस्क (18-59)",
      "senior": "वरिष्ठ नागरिक (60+)",
      "unknown": "अज्ञात"
    }
  },
  "profileDeep": {
    "backToDashboard": "डैशबोर्ड पर वापस",
    "profileCompletion": "प्रोफ़ाइल पूर्णता",
    "healthSummary": "स्वास्थ्य सारांश",
    "sectionA": "खंड A",
    "sectionB": "खंड B",
    "sectionC": "खंड C",
    "sectionD": "खंड D",
    "personalDetails": "व्यक्तिगत विवरण",
    "healthInformation": "स्वास्थ्य जानकारी",
    "accountSettings": "खाता सेटिंग्स",
    "fullName": "पूरा नाम",
    "email": "ईमेल",
    "dob": "जन्म तिथि",
    "gender": "लिंग",
    "genderPlaceholder": "जैसे: महिला, पुरुष, ग़ैर-द्विआधारी",
    "height": "क़द (सेमी)",
    "heightPlaceholder": "जैसे: 170",
    "weight": "वज़न (किग्रा)",
    "weightPlaceholder": "जैसे: 70",
    "allergies": "एलर्जी",
    "allergiesPlaceholder": "जैसे: मूँगफली",
    "medicalConditions": "चिकित्सीय स्थितियाँ",
    "conditionsPlaceholder": "जैसे: उच्च रक्तचाप",
    "medications": "दवाएँ",
    "medicationsPlaceholder": "जैसे: लिसिनोप्रिल 10mg, रोज़ाना",
    "emergencyContact": "आपातकालीन संपर्क",
    "emergencyOptional": "(वैकल्पिक)",
    "emergencyPlaceholder": "जैसे: माँ +91-98000-00000",
    "emergencyNote": "केवल तभी शामिल किया जाएगा जब आप क्लिनिशियन से साझा करेंगे।",
    "saveChanges": "परिवर्तन सहेजें",
    "saving": "सहेजा जा रहा है…",
    "editProfile": "प्रोफ़ाइल संपादित करें",
    "cancelEditing": "संपादन रद्द करें",
    "healthScore": "स्वास्थ्य स्कोर",
    "streak": "लय",
    "streakDays": "{{n}} दिन",
    "memberSince": "सदस्य कब से",
    "remindersActive": "सक्रिय रिमाइंडर",
    "conditionsTracked": "ट्रैक की गई स्थितियाँ",
    "nextAgenda": "आपके एजेंडे में अगला",
    "notificationsReminders": "सूचनाएँ और रिमाइंडर",
    "notificationsRemindersDesc": "समय और चैनलों का प्रबंधन करें",
    "emailNudges": "ईमेल रिमाइंडर",
    "emailNudgesDesc": "विनम्र रिमाइंडर और साप्ताहिक सारांश",
    "on": "चालू",
    "paused": "रुका हुआ",
    "privacySecurity": "गोपनीयता और सुरक्षा",
    "privacySecurityDesc": "अपना पासवर्ड अपडेट करके खाता सुरक्षित रखें",
    "preferencesTitle": "प्राथमिकताएँ",
    "preferencesDesc": "भाषा, क्षेत्र और निजीकरण",
    "supportHelp": "मदद और सहायता",
    "supportHelpDesc": "जवाब पाएँ या सहायता से संपर्क करें",
    "sectionAccount": "खाता",
    "sectionSupport": "सहायता",
    "sectionAbout": "ऐप के बारे में",
    "sectionAdmin": "व्यवस्थापक",
    "privacyPolicy": "गोपनीयता नीति",
    "terms": "शर्तें",
    "appVersion": "ऐप संस्करण",
    "giveFeedback": "फ़ीडबैक दें",
    "giveFeedbackDesc": "बताएँ क्या बेहतर हो सकता है",
    "reportProblem": "समस्या रिपोर्ट करें",
    "reportProblemDesc": "कोई बग मिला? हमें बताएँ",
    "adminInsights": "व्यवस्थापक इनसाइट्स",
    "adminInsightsDesc": "सहभागिता विश्लेषिकी",
    "adminBadge": "व्यवस्थापक",
    "shareWithClinician": "क्लिनिशियन के साथ साझा करें",
    "shareWithClinicianDesc": "केवल पढ़ें · स्वतः समाप्त · कभी भी रद्द करें",
    "share": "साझा करें",
    "profileMayBeOutOfDate": "प्रोफ़ाइल पुरानी हो सकती है",
    "profileMayBeOutOfDateDesc": "बेहतर सुझावों के लिए डेटा अपडेट रखें — छोटे बदलाव (वज़न, दवा) हमारी सलाह को बेहतर बनाते हैं।",
    "updateNow": "अभी अपडेट करें",
    "profileUpdateError": "प्राथमिकता अपडेट नहीं हो सकी। कृपया फिर कोशिश करें।",
    "healthLoopUser": "HealthLoop उपयोगकर्ता",
    "updatedLabel": "अपडेट",
    "noEntries": "अभी कोई प्रविष्टि नहीं।",
    "completionComplete": "आपका प्रोफ़ाइल पूरा है। हम सर्वोत्तम मार्गदर्शन दे सकते हैं। 💚",
    "completionAlmostThere": "लगभग हो गया। थोड़ी और जानकारी से बेहतर सलाह।",
    "completionInProgress": "बेहतर कल्याण सलाह के लिए प्रोफ़ाइल पूरी करें।",
    "justNow": "अभी-अभी",
    "minAgo": "{{n}} मिनट पहले",
    "minsAgo": "{{n}} मिनट पहले",
    "hourAgo": "{{n}} घंटा पहले",
    "hoursAgo": "{{n}} घंटे पहले",
    "dayAgo": "{{n}} दिन पहले",
    "daysAgo": "{{n}} दिन पहले",
    "checkinDueToday": "आज चेक-इन बाक़ी",
    "checkinDueTonight": "आज रात चेक-इन बाक़ी"
  },
  "supportDeep": {
    "backToSettings": "सेटिंग्स पर वापस",
    "quickNavAria": "सहायता अनुभाग",
    "searchPlaceholder": "सहायता खोजें…",
    "searchAria": "पूछे जाने वाले प्रश्न खोजें",
    "resultsCount": "{{n}} परिणाम",
    "resultsCountPlural": "{{n}} परिणाम",
    "questionsCount": "{{n}} प्रश्न",
    "liveChatTitle": "लाइव चैट",
    "liveChatDesc": "रीयल-टाइम में बात करें · सोम–शुक्र 9 बजे – 6 बजे",
    "startChat": "चैट शुरू करें",
    "liveChatSoonToast": "लाइव चैट जल्द आ रही है। तब तक ईमेल बढ़िया विकल्प है।",
    "emailUsTitle": "हमें लिखें",
    "emailUsDesc": "24–48 घंटे में उत्तर",
    "copy": "कॉपी करें",
    "emailCopied": "ईमेल कॉपी हुआ।",
    "contactFormTitle": "संपर्क फ़ॉर्म",
    "contactFormDesc": "हमें संदेश भेजें — हम ईमेल पर उत्तर देंगे।",
    "yourNameLabel": "आपका नाम *",
    "namePlaceholder": "राहुल शर्मा",
    "yourEmailLabel": "आपका ईमेल *",
    "emailPlaceholder": "rahul@example.com",
    "subjectOptional": "विषय (वैकल्पिक)",
    "subjectPlaceholder": "हम कैसे मदद कर सकते हैं?",
    "messageLabel": "संदेश *",
    "messagePlaceholder": "थोड़े में बताएँ कि आपको क्या चाहिए।",
    "sending": "भेज रहा है…",
    "sendMessage": "संदेश भेजें",
    "messageSent": "संदेश भेजा गया",
    "messageSentDesc": "हम 24–48 घंटे में उत्तर देंगे।",
    "callbackTitle": "कॉलबैक माँगें",
    "callbackDesc": "जब आपको सुविधा हो, हम कॉल करेंगे।",
    "phoneLabel": "फ़ोन नंबर *",
    "phonePlaceholder": "+91 98000 00000",
    "preferredTimeLabel": "पसंदीदा समय (वैकल्पिक)",
    "preferredTimePlaceholder": "जैसे: कल दोपहर",
    "reasonLabel": "कारण (वैकल्पिक)",
    "reasonPlaceholder": "संक्षेप में, किस बारे में बात करना चाहेंगे?",
    "submitting": "जमा हो रहा है…",
    "requestCallback": "कॉलबैक माँगें",
    "callbackRequested": "कॉलबैक रिक्वेस्ट दर्ज",
    "callbackRequestedDesc": "24 घंटे में संपर्क करेंगे।",
    "medicationSupport": "दवा सहायता",
    "medicationSupportDesc": "नुस्ख़े, रीफ़िल और रिमाइंडर ट्रैक करें।",
    "goToMedications": "दवाओं पर जाएँ →",
    "specialistConsultation": "विशेषज्ञ परामर्श",
    "specialistConsultationDesc": "व्यक्तिगत स्वास्थ्य मार्गदर्शन के लिए क्लिनिशियन से जुड़ें।",
    "connectExpert": "विशेषज्ञ से जुड़ें →",
    "videoConsult": "वीडियो परामर्श",
    "videoConsultDesc": "विशेषज्ञ के साथ वीडियो सत्र बुक करें।",
    "bookConsultation": "परामर्श बुक करें →",
    "premium": "प्रीमियम",
    "healthDisclaimer": "HealthLoop आपके दैनिक स्वास्थ्य का साथ देता है — आपातकालीन देखभाल का विकल्प नहीं है। आपात स्थिति में स्थानीय आपातकालीन सेवाएँ संपर्क करें।",
    "categoryLabel": "श्रेणी",
    "catBug": "बग / त्रुटि",
    "catPerformance": "धीमी गति",
    "catFeature": "फ़ीचर काम नहीं कर रहा",
    "catUi": "डिस्प्ले समस्या",
    "catOther": "अन्य",
    "issueTitle": "समस्या शीर्षक *",
    "issueTitlePlaceholder": "संक्षिप्त सारांश",
    "detailedDescription": "विस्तृत विवरण *",
    "detailedDescriptionPlaceholder": "क्या हुआ? आप क्या कर रहे थे? पुनरुत्पादन के चरण हमें बहुत मदद करते हैं।",
    "autoAttachNote": "डिवाइस, ब्राउज़र और व्यूपोर्ट जानकारी अपने आप अटैच होती है।",
    "submitReport": "रिपोर्ट जमा करें",
    "reportSubmitted": "रिपोर्ट जमा हुई",
    "reportSubmittedDesc": "हमारी टीम इस पर काम कर रही है।",
    "fillAllFields": "कृपया सभी आवश्यक फ़ील्ड भरें",
    "problemReportSubmittedToast": "समस्या रिपोर्ट जमा हुई। हम जाँच करके आपसे संपर्क करेंगे।",
    "messageSentToast": "संदेश भेजा गया। हम 24–48 घंटे में उत्तर देंगे।",
    "callRequestedToast": "कॉल अनुरोध मिला। हम 24 घंटे में संपर्क करेंगे।",
    "submitFailGeneric": "जमा नहीं हो सका। फिर कोशिश करें या {{email}} पर लिखें।",
    "submitFailContact": "भेज नहीं सके। सीधे {{email}} पर लिखें।"
  },
  "careServices": {
    "pageTitle": "Care Services",
    "pageSubtitle": "Clinical and wellness support designed for your everyday health journey.",
    "specialistCareTitle": "Specialist Care",
    "specialistCareSubtitle": "Talk to clinicians and book the right specialist when you need one.",
    "medicationPharmacyTitle": "Medication & Pharmacy",
    "medicationPharmacySubtitle": "Plain-language medication guidance and pharmacy help.",
    "wellnessSupportTitle": "Wellness Support",
    "wellnessSupportSubtitle": "Mental wellness, over-the-counter guidance, and a clear next-step path.",
    "futureWellnessTitle": "Future Wellness Features",
    "futureWellnessSubtitle": "A preview of what's on HealthLoop's preventive-wellness roadmap.",
    "futureFeatureBadge": "Future Feature",
    "futurePersonalizedMealsTitle": "Personalized Meal Plans",
    "futurePersonalizedMealsDesc": "Wellness-led meal plans tuned to your goals, allergies, and culture.",
    "futureHealthyDeliveryTitle": "Healthy Meal Delivery",
    "futureHealthyDeliveryDesc": "Curated delivery from health-conscious kitchens and partners.",
    "futureFarmFreshTitle": "Farm-Fresh Wellness Foods",
    "futureFarmFreshDesc": "Direct access to local farms and seasonal fresh-produce partners.",
    "futureFoodPartnershipsTitle": "Wellness Food Partnerships",
    "futureFoodPartnershipsDesc": "Curated relationships with healthy kitchens, grocers, and wellness brands.",
    "futureNutritionCoachingTitle": "Nutrition Coaching",
    "futureNutritionCoachingDesc": "One-to-one guidance from credentialed nutrition coaches.",
    "futureFamilyWellnessTitle": "Family Wellness Plans",
    "futureFamilyWellnessDesc": "Shared plans that keep the whole household on track.",
    "futureWellnessPlusTitle": "Wellness+ Membership",
    "futureWellnessPlusDesc": "A premium tier for personalised guidance, priority support, and deeper insights.",
    "futurePharmacyPartnersTitle": "Pharmacy Partnerships",
    "futurePharmacyPartnersDesc": "Trusted pharmacy connections for medication guidance and refills.",
    "futureAdvancedSpecialistTitle": "Advanced Specialist Care",
    "futureAdvancedSpecialistDesc": "Coordinated access to specialists, second opinions, and care navigation.",
    "futureWellnessMarketplaceTitle": "Wellness Marketplace",
    "futureWellnessMarketplaceDesc": "A curated marketplace of vetted wellness products and services.",
    "futureVendorCollabTitle": "Vendor Collaboration Systems",
    "futureVendorCollabDesc": "Onboarding and quality systems for healthy food and wellness partners."
  },
  "dashboardDeep": {
    "healthProfile": "स्वास्थ्य प्रोफ़ाइल",
    "notifications": "सूचनाएँ",
    "familyAccounts": "परिवार खाते",
    "settings": "सेटिंग्स",
    "logout": "लॉग आउट",
    "allCaughtUp": "सब अपडेट है।",
    "weekInReview": "आपका सप्ताह संक्षेप में",
    "dismissNotification": "सूचना हटाएँ",
    "dismissWeeklyDigest": "साप्ताहिक सार हटाएँ",
    "notificationsAria": "सूचनाएँ",
    "profileMenuAria": "प्रोफ़ाइल मेनू खोलें",
    "loadingWellness": "आपका कल्याण सार लोड हो रहा है",
    "nextTip": "अगली सलाह",
    "todayAtGlance": "आज एक नज़र में",
    "healthScoreLabel": "स्वास्थ्य स्कोर",
    "currentStreakLabel": "मौजूदा लय",
    "todaysProgress": "आज की प्रगति",
    "insightForYou": "आपके लिए सीख",
    "checkMyHealthRisk": "मेरा स्वास्थ्य जोखिम जाँचें",
    "quickAccess": "त्वरित पहुँच",
    "familyCare": "परिवार देखभाल",
    "healthLibrary": "स्वास्थ्य पुस्तकालय",
    "myHealthData": "मेरा स्वास्थ्य डेटा",
    "askQuestion": "प्रश्न पूछें",
    "dashLoadError": "डैशबोर्ड लोड नहीं हो सका। फिर कोशिश करें।",
    "taskUpdateError": "कार्य अपडेट नहीं हो सका। फिर कोशिश करें।",
    "perfectDay": "शानदार दिन! 🎉 लय बढ़ी।",
    "letsStart": "चलिए शुरू करें",
    "yourNextStepToday": "आज का अगला कदम",
    "completeDailyCheck": "अपना दैनिक स्वास्थ्य चेक पूरा करें",
    "startDailyCheck": "दैनिक चेक शुरू करें",
    "viewAll": "सभी देखें",
    "graceProtected": "अनुग्रह सुरक्षित",
    "todaysHealthRecommendations": "आज की स्वास्थ्य सिफ़ारिशें",
    "updateViaCheck": "दैनिक चेक से अपडेट करें",
    "healthInsight": "स्वास्थ्य सीख",
    "riskCheckSubtext": "सेकेंडों में निजी स्वास्थ्य सलाह पाएँ",
    "foodDiet": "भोजन और आहार",
    "healthScoreNew": "स्वास्थ्य स्कोर · नया",
    "letsBuildScore": "चलिए साथ मिलकर आपका स्वास्थ्य स्कोर बनाएँ",
    "oneHealthyHabitAtATime": "एक समय में एक स्वस्थ आदत।",
    "nextCheck": "अगला चेक:",
    "todayAt8pm": "आज रात 8:00 बजे",
    "wellnessTipForYou": "आज की कल्याण सलाह · आपके लिए",
    "wellnessTipForFactor": "आज की कल्याण सलाह · आपके {{factor}} के लिए",
    "logged": "दर्ज हुआ",
    "gotIt": "समझ गए 👍",
    "gladToSeeYou": "आपको आज देखकर खुशी हुई 💚",
    "takesLessThan60Sec": "60 सेकंड से कम",
    "scoreReadyWhenYou": "जब आप तैयार हों",
    "scoreCompleteFirstCheck": "निजी सलाह अनलॉक करने के लिए पहला चेक करें।",
    "scoreExcellent": "उत्कृष्ट",
    "scoreSupportExcellent": "आज आप शानदार स्थिति में हैं। ऐसे ही बनाए रखें।",
    "scoreGood": "अच्छा",
    "scoreSupportGood": "अच्छा कर रहे हैं। अपनी स्वस्थ आदतें जारी रखें।",
    "scoreModerate": "सामान्य",
    "scoreSupportModerate": "ठीक चल रहे हैं, पर कुछ क्षेत्र ध्यान चाहते हैं।",
    "scoreNeedsAttention": "ध्यान चाहिए",
    "scoreSupportNeedsAttention": "आज आपके स्वास्थ्य पर ध्यान देने की ज़रूरत है। छोटे बदलाव मदद कर सकते हैं।"
  },
  "emailVerify": {
    "bannerWithEmail": "कृपया अपना ईमेल ({{email}}) सत्यापित करें ताकि हम आपका खाता सुरक्षित रख सकें।",
    "bannerNoEmail": "कृपया अपना ईमेल सत्यापित करें ताकि हम आपका खाता सुरक्षित रख सकें।",
    "sending": "भेज रहा है…",
    "resend": "फिर भेजें",
    "sentToast": "सत्यापन ईमेल भेजा गया। इनबॉक्स देखें।",
    "sendFailToast": "ईमेल नहीं भेजा जा सका। बाद में कोशिश करें।"
  },
  "forgotPassword": {
    "title": "पासवर्ड भूल गए?",
    "subtitle": "चिंता नहीं! अपना ईमेल दें, हम रीसेट निर्देश भेजेंगे।",
    "emailLabel": "ईमेल पता",
    "emailPlaceholder": "aap@example.com",
    "sendResetLink": "रीसेट लिंक भेजें",
    "sending": "भेज रहे हैं…",
    "backToLogin": "साइन इन पर वापस",
    "resendLink": "ईमेल फिर भेजें",
    "successTitle": "ईमेल देखें",
    "successBody": "{{email}} के लिए खाता मौजूद है तो रीसेट लिंक भेज दिया गया।",
    "linkExpires": "लिंक 30 मिनट में समाप्त होगा।",
    "successToast": "रीसेट निर्देशों के लिए अपना ईमेल देखें",
    "errEmptyEmail": "कृपया अपना ईमेल दर्ज करें",
    "errInvalidEmail": "कृपया मान्य ईमेल दर्ज करें",
    "errNetwork": "सर्वर से जुड़ नहीं सके। कनेक्शन जाँचें।",
    "errGeneric": "ईमेल नहीं भेज सके। फिर कोशिश करें या सहायता से संपर्क करें।"
  },
  "resetPassword": {
    "title": "नया पासवर्ड सेट करें",
    "subtitle": "अपने खाते के लिए मज़बूत पासवर्ड बनाएँ",
    "newPasswordLabel": "नया पासवर्ड",
    "newPasswordPlaceholder": "नया पासवर्ड डालें",
    "confirmPasswordLabel": "पासवर्ड पुष्टि करें",
    "confirmPasswordPlaceholder": "नया पासवर्ड दोबारा डालें",
    "requirementsHint": "कम से कम 8 अक्षर, अपरकेस/लोअरकेस/संख्या सहित",
    "resetPassword": "पासवर्ड रीसेट करें",
    "resetting": "रीसेट हो रहा है…",
    "successTitle": "पासवर्ड रीसेट सफल!",
    "successBody": "अब आप नए पासवर्ड से साइन इन कर सकते हैं।",
    "successToast": "पासवर्ड सफलतापूर्वक रीसेट हो गया!",
    "goToLogin": "साइन इन पर जाएँ",
    "invalidLinkTitle": "अमान्य लिंक",
    "invalidLinkBody": "यह रीसेट लिंक अमान्य है या समाप्त हो गया।",
    "requestNewLink": "नया लिंक माँगें",
    "showPassword": "पासवर्ड दिखाएँ",
    "hidePassword": "पासवर्ड छिपाएँ",
    "errInvalidLink": "अमान्य रीसेट लिंक",
    "errMismatch": "पासवर्ड मेल नहीं खाते",
    "errTooShort": "पासवर्ड कम से कम 8 अक्षरों का होना चाहिए",
    "errExpiredToken": "यह लिंक समाप्त है या अमान्य है। नया माँगें।",
    "errNetwork": "सर्वर से जुड़ नहीं सके। कनेक्शन जाँचें।",
    "errGeneric": "पासवर्ड रीसेट नहीं हो सका। फिर कोशिश करें।"
  },
  "tips": {
    "water1": "जागने के 30 मिनट के भीतर पानी पीना हाइड्रेशन और ऊर्जा बेहतर कर सकता है।",
    "water2": "हर भोजन से पहले एक गिलास पानी प्यास से आगे रहने का सरल तरीका है।",
    "water3": "नींबू का एक टुकड़ा या पुदीना मिलाकर पानी पीना मज़ेदार बनता है।",
    "meals1": "दिन में एक अतिरिक्त सब्ज़ी की प्लेट आँतों और हृदय के स्वास्थ्य को सहारा देती है।",
    "meals2": "नाश्ते में मुट्ठीभर मेवे या बीज सुबह आपकी ऊर्जा स्थिर रखते हैं।",
    "meals3": "जूस से बेहतर है पूरा फल — फ़ाइबर ब्लड शुगर को सौम्य रखती है।",
    "steps1": "भोजन के बाद 10 मिनट की चहलक़दमी शर्करा को आराम से पचाने में मदद करती है।",
    "steps2": "सुबह 5 मिनट का स्ट्रेच तनाव कम करता है और दिन को शांत स्वर देता है।",
    "steps3": "दिन में एक बार सीढ़ियाँ चढ़ना धीरे-धीरे हृदय को मज़बूत करता है।",
    "sleep1": "सोने से एक घंटा पहले रोशनी कम करना गहरी नींद के लिए शरीर तैयार करता है।",
    "sleep2": "जागने का तय समय — सप्ताहांत पर भी — नींद चक्र को स्थिर रखता है।",
    "sleep3": "सुबह की 10 मिनट धूप नींद की लय को स्वाभाविक रूप से नियंत्रित करती है।",
    "general1": "दो मिनट की धीमी साँसें तनाव कम कर ध्यान को स्थिर कर सकती हैं।",
    "general2": "आज एक पल कृतज्ञता का खोजें — छोटे मानसिक जीत भी जुड़ती जाती हैं।",
    "general3": "आज आप यहाँ हैं। यही वह आदत है जो बाकी सबको आसान बनाती है।"
  },
  "factors": {
    "hydration": "हाइड्रेशन",
    "nutrition": "पोषण",
    "movement": "गति",
    "sleep": "नींद"
  },
  "nutritionDeep": {
    "sectionSnapshot": "दैनिक पोषण स्नैपशॉट",
    "sectionSnapshotSubtitle": "आज के लिए हाइड्रेशन, कैलोरी और भोजन संतुलन पर एक त्वरित नज़र।",
    "mealOptionsLoadFail": "भोजन विकल्प लोड नहीं हो सके",
    "prefsSaved": "भोजन प्राथमिकताएँ सहेजी गईं! रिफ़्रेश हो रहा है...",
    "prefsSaveFail": "प्राथमिकताएँ सहेजने में विफल",
    "newOptionsFail": "नए विकल्प लोड नहीं हो सके",
    "invalidZip": "कृपया मान्य 5-अंकीय ज़िप कोड दर्ज करें",
    "noVendorsArea": "अभी इस क्षेत्र में कोई वेंडर उपलब्ध नहीं। हम कवरेज बढ़ा रहे हैं!",
    "vendorsFetchFail": "वेंडर लाने में विफल",
    "selectVendorFirst": "कृपया पहले डिलीवरी वेंडर चुनें",
    "removedFromCart": "कार्ट से हटाया गया",
    "orderPlaced": "ऑर्डर सफलतापूर्वक दिया गया! 🎉",
    "enterZipFirst": "पहले डिलीवरी सेक्शन में अपना ज़िप कोड दर्ज करें",
    "mealNotAvailable": "यह भोजन अभी आपके क्षेत्र में डिलीवरी के लिए उपलब्ध नहीं",
    "mealUnavailable": "यह भोजन निकटवर्ती वेंडर से अभी उपलब्ध नहीं",
    "vendorOptionsFail": "वेंडर विकल्प लोड नहीं हो सके",
    "favoriteSaveFail": "पसंदीदा सहेजने में विफल",
    "removedFromFavorites": "पसंदीदा से हटाया",
    "favoriteRemoveFail": "पसंदीदा हटाने में विफल",
    "cartEmpty": "आपका कार्ट खाली है",
    "noMealOptions": "कोई भोजन विकल्प उपलब्ध नहीं",
    "loadingOptions": "भोजन विकल्प लोड हो रहे हैं...",
    "selectPreferences": "अपनी भोजन प्राथमिकताएँ चुनें",
    "mealBuilder": "भोजन बनाएँ",
    "myFavorites": "मेरे पसंदीदा",
    "myFavoriteMeals": "मेरे पसंदीदा भोजन",
    "noFavoritesYet": "अभी कोई पसंदीदा भोजन नहीं!",
    "price": "मूल्य",
    "delivery": "डिलीवरी",
    "deliveryFee": "डिलीवरी शुल्क",
    "distance": "दूरी",
    "subtotal": "उप-योग",
    "total": "कुल",
    "orderNumber": "ऑर्डर नंबर",
    "vendor": "वेंडर",
    "totalAmount": "कुल राशि",
    "estimatedDelivery": "अनुमानित डिलीवरी",
    "whyThisMeal": "यह भोजन क्यों",
    "selectThisMeal": "इस भोजन को चुनें",
    "swapMeal": "भोजन बदलें",
    "orderThisMeal": "इस भोजन का ऑर्डर दें",
    "notAvailableNearYou": "आपके पास उपलब्ध नहीं",
    "tryAdjustingPrefs": "सुझाव देखने के लिए अपनी भोजन प्राथमिकताएँ बदलें",
    "myMealPlanSummary": "मेरी भोजन योजना",
    "saveCompletePlan": "पूरी योजना सहेजें",
    "yourFoodPreferences": "आपकी भोजन प्राथमिकताएँ",
    "editPreferences": "प्राथमिकताएँ संपादित करें",
    "healthyMealDelivery": "स्वस्थ भोजन डिलीवरी",
    "enableDelivery": "डिलीवरी सक्षम करें",
    "enterZipCode": "उपलब्ध भोजन देखने के लिए ज़िप कोड दर्ज करें",
    "savePreferences": "प्राथमिकताएँ सहेजें",
    "quickAccessSavedMeals": "सहेजे भोजन तक त्वरित पहुँच",
    "saveMealsFromBuilder": "भोजन बनाएँ टैब से भोजन सहेजें",
    "chooseVendor": "इस भोजन के लिए वेंडर चुनें",
    "yourCart": "आपका कार्ट",
    "addMealsToStart": "शुरू करने के लिए नीचे से भोजन जोड़ें",
    "orderPlacedDesc": "आपका स्वस्थ भोजन ऑर्डर सफलतापूर्वक दिया गया",
    "continueShopping": "खरीदारी जारी रखें",
    "trackOrder": "ऑर्डर ट्रैक करें",
    "healthyStoresTitle": "पास के हेल्दी स्टोर्स और वेलनेस मार्केट",
    "healthyStoresIntro": "अपने क्षेत्र में तलाशने के लिए सांस्कृतिक रूप से समावेशी स्टोर के प्रकार — ये केवल सुझाव के लिए हैं, डिलीवरी के लिए नहीं।",
    "healthyStoresGuidanceTitle": "स्वस्थ खरीदारी मार्गदर्शन",
    "healthyStoresDisclaimer": "HealthLoop केवल सामान्य वेलनेस और स्वस्थ खरीदारी की प्रेरणा साझा करता है — यह चिकित्सा या आहार संबंधी उपचार मार्गदर्शन नहीं है।",
    "healthyStores": {
      "organic": {
        "type": "ऑर्गेनिक किराने की दुकानें",
        "description": "ताज़ी, कीटनाशक मुक्त उपज और कम प्रोसेस्ड पेंट्री सामग्री।",
        "tags": [
          "होल-फूड्स",
          "ताज़ी उपज"
        ]
      },
      "farmers": {
        "type": "किसान बाज़ार",
        "description": "सीधे उत्पादकों से मिलने वाले स्थानीय मौसमी फल, सब्जियां और पारंपरिक उपज।",
        "tags": [
          "स्थानीय",
          "मौसमी"
        ]
      },
      "african": {
        "type": "अफ्रीकी ताज़ा उपज स्टोर",
        "description": "रतालू, केला, पत्तेदार सब्जियां, पाम नट और पश्चिम/पूर्वी अफ्रीकी मुख्य खाद्य पदार्थ।",
        "tags": [
          "सांस्कृतिक",
          "ताज़ी उपज"
        ]
      },
      "caribbean": {
        "type": "कैरेबियन प्राकृतिक खाद्य बाज़ार",
        "description": "कैलालू, कसावा, स्कॉच बोनट, अकी, ब्रेडफ्रूट और द्वीप के मुख्य खाद्य पदार्थ।",
        "tags": [
          "सांस्कृतिक",
          "होल-फूड्स"
        ]
      },
      "asian": {
        "type": "एशियाई सब्जी सुपरमार्केट",
        "description": "बोक चोय, मूली, कमल ककड़ी, टोफू, ताजी जड़ी-बूटियाँ और अखिल एशियाई मुख्य खाद्य पदार्थ।",
        "tags": [
          "सांस्कृतिक",
          "ताज़ी उपज"
        ]
      },
      "halal": {
        "type": "हलाल स्वस्थ खाद्य बाज़ार",
        "description": "हलाल-प्रमाणित लीन प्रोटीन, ताज़ा उपज और पारंपरिक मसाले।",
        "tags": [
          "हलाल",
          "सांस्कृतिक"
        ]
      },
      "mediterranean": {
        "type": "भूमध्यसागरीय (मेडितेरेनियन) होल-फूड मार्केट",
        "description": "जैतून का तेल, फलियां, ताजी जड़ी-बूटियां, साबुत अनाज और भूमध्यसागरीय मुख्य खाद्य पदार्थ।",
        "tags": [
          "सांस्कृतिक",
          "होल-फूड्स"
        ]
      },
      "wellness": {
        "type": "वेलनेस-केंद्रित किराने की दुकानें",
        "description": "चुनिंदा होल-फूड्स, पौधों पर आधारित (प्लांट-बेस्ड) विकल्प और शुद्ध पेंट्री आइटम।",
        "tags": [
          "होल-फूड्स",
          "प्लांट-बेस्ड"
        ]
      }
    },
    "healthyShoppingTips": [
      "पहले बाहरी घेरे (पेरिमीटर) में खरीदारी करें — ताज़ा उपज, लीन प्रोटीन और डेयरी विकल्प आमतौर पर वहीं मिलते हैं।",
      "भारी प्रोसेस्ड वस्तुओं के बजाय साबुत, एकल-सामग्री वाले खाद्य पदार्थों को प्राथमिकता दें।",
      "मौसमी स्थानीय उपज चुनें — यह आमतौर पर ताज़ा, सस्ती और अधिक पोषक तत्वों से भरपूर होती है।",
      "विक्रेताओं से उपज की उत्पत्ति और उगाने के तरीकों के बारे में पूछें — कई खुशी-खुशी जानकारी साझा करेंगे।"
    ]
  },
  "messages": {
    "success": "Success!",
    "error": "Error",
    "saved": "Saved successfully",
    "updated": "Updated successfully",
    "deleted": "Deleted successfully",
    "confirmDelete": "Are you sure you want to delete this?",
    "networkError": "Network error. Please try again.",
    "somethingWrong": "Something went wrong",
    "failedToLoad": "Failed to load dashboard",
    "offlineMode": "Offline mode - showing limited data",
    "locationDenied": "Location access denied. Check browser settings to enable.",
    "locationUnavailable": "Location information unavailable",
    "locationTimeout": "Location request timed out. Please try again.",
    "locationError": "Unable to access location",
    "locationGranted": "Location access granted! Showing nearby options",
    "locationNotSupported": "Location services not supported by your browser",
    "requestingLocation": "Requesting location access..."
  },
  "trust": {
    "medicalDisclaimer": "Medical Disclaimer",
    "privacySecure": "Your data is private & secure",
    "dataEncrypted": "All data is encrypted and confidential",
    "notMedicalAdvice": "Not medical advice",
    "consultProvider": "Always consult your healthcare provider",
    "evidenceBased": "Evidence-based guidance",
    "generalEducation": "General health education",
    "preventiveGuidance": "Preventive guidance",
    "lifestyleSupport": "For awareness and lifestyle support",
    "lastUpdated": "Last updated",
    "expertReviewed": "Expert reviewed",
    "aiGenerated": "AI-generated insight",
    "disclaimerShort": "HealthLoop provides health education and is not a substitute for professional medical advice.",
    "disclaimerFull": "HealthLoop supports preventive wellness and early awareness. We provide health education, habit tracking, and wellness insights. This is not a substitute for licensed medical care. Always consult qualified healthcare providers for medical advice, diagnosis, or treatment.",
    "trustBanner": {
      "title": "HealthLoop is here to support your wellness journey",
      "description": "We provide general health education and preventive guidance based on trusted sources. This is not a substitute for professional medical advice. Always consult with qualified healthcare providers for medical decisions."
    }
  },
  "health": {
    "preventiveHealth": "Preventive Health Tracker",
    "educationHub": "Education Hub",
    "engagementWidget": "Engagement Widget",
    "wellnessCheckIn": "Wellness Check-In",
    "todaysMetrics": "Today's Metrics",
    "bloodPressure": "Blood Pressure",
    "heartRate": "Heart Rate",
    "weight": "Weight",
    "sleep": "Sleep",
    "waterIntake": "Water Intake",
    "exercise": "Exercise",
    "logMetric": "Log Metric",
    "viewHistory": "View History"
  },
  "aiInsights": {
    "title": "AI Health Insights",
    "comingSoon": "Your insights are gathering",
    "comingSoonDesc": "Complete a daily check-in or two and we'll surface gentle, personalised insights here.",
    "learnMore": "Learn more",
    "evidenceSources": {
      "WHO": "Based on WHO guidelines",
      "NHS": "Aligned with NHS recommendations",
      "CDC": "Supported by CDC guidelines",
      "RESEARCH": "Based on peer-reviewed research",
      "CLINICAL": "Backed by clinical studies"
    }
  },
  "dailyInsight": {
    "title": "Daily Health Insight",
    "gettingStarted": "Getting Started",
    "focus": "Focus",
    "quickInsight": "Quick Insight",
    "simpleExplanation": "Simple Explanation",
    "realLifeImpact": "Real-Life Impact",
    "yourActionStep": "Your Action Step",
    "basedOnYour": "Based on your",
    "personalizedFor": "Personalized for you based on your recent health data",
    "getNewInsight": "Get new insight",
    "newInsightLoaded": "New insight loaded! 💡",
    "failedToRefresh": "Failed to refresh insight",
    "priority": {
      "high": "Let's Focus Here",
      "medium": "Worth Noting"
    }
  },
  "preventiveAlerts": {
    "noAlertsTitle": "No health alerts at this time",
    "noAlertsDesc": "You're maintaining healthy habits. Keep it up!",
    "whatYouCanDo": "What you can do:",
    "viewMealSuggestions": "View Personalized Meal Suggestions"
  },
  "engagement": {
    "currentStreak": "Current Streak",
    "bestStreak": "Best Streak",
    "thisWeek": "This Week",
    "exerciseDays": "Exercise Days",
    "hydrationDays": "Hydration Days",
    "healthMetricsLogged": "Health Metrics Logged",
    "weeklyGoalsProgress": "Weekly Goals Progress",
    "completed": "completed",
    "days": "days",
    "keepGoing": "Keep going!",
    "personalRecord": "Personal record!",
    "goalMet": "Goal met!"
  },
  "reminders": {
    "title": "Health Reminders",
    "subtitle": "Stay on track with personalized health notifications",
    "breakfast": "Breakfast Reminder",
    "lunch": "Lunch Reminder",
    "dinner": "Dinner Reminder",
    "water": "Water Intake",
    "movement": "Movement Break",
    "sleep": "Sleep Reminder",
    "wellness": "Wellness Check-In",
    "healthLogging": "Health Logging",
    "annualCheckup": "Annual Checkup",
    "enable": "Enable",
    "disable": "Disable",
    "customize": "Customize Time",
    "stayConsistent": "Stay Consistent with Smart Reminders",
    "setupFriendly": "Set up friendly reminders to help you build healthy habits.",
    "customizeWhen": "You can customize when and how often you receive each reminder.",
    "supportive": "Don't worry - we'll keep them supportive and non-intrusive! 💚",
    "noPreferences": "No Reminder Preferences Found",
    "noPreferencesDesc": "We couldn't load your reminder settings. This might be your first time here, or there was an issue loading your preferences.",
    "retryLoading": "Retry Loading",
    "saveSettings": "Save Settings",
    "saving": "Saving..."
  },
  "empty": {
    "startJourney": "Start Your Wellness Journey",
    "startJourneyDesc": "Start your health journey today! Share how you're feeling to receive personalized insights and track your wellness over time.",
    "completeFirstCheckIn": "Complete First Check-in",
    "stayOnTrack": "Stay On Track",
    "stayOnTrackDesc": "Stay consistent with your routine 💊 Add your medications to get gentle reminders and support.",
    "addFirstMedication": "Add First Medication",
    "learnMedicationSafety": "Learn About Medication Safety",
    "buildMealLibrary": "Build Your Meal Library",
    "buildMealLibraryDesc": "No favorite meals yet. Save meals you love for quick access and easier meal planning.",
    "exploreMealOptions": "Explore Meal Options",
    "insightsAwait": "Your Insights Await",
    "insightsAwaitDesc": "Complete daily check-ins and track your wellness to unlock personalized health insights and pattern analysis.",
    "startDailyCheckIn": "Start Daily Check-in",
    "learnAboutInsights": "Learn About Insights",
    "buildingStory": "Building Your Wellness Story",
    "buildingStoryDesc": "No historical data yet. Your wellness trends and patterns will appear here as you complete daily check-ins.",
    "completeCheckIn": "Complete Check-in",
    "tipComplete7Days": "Tip: Complete check-ins for 7 days to see meaningful trends and patterns.",
    "startTrackingHabits": "Start Tracking Healthy Habits",
    "startTrackingHabitsDesc": "No habits tracked yet. Small daily actions create lasting wellness changes. Begin building your healthy routine today.",
    "trackFirstHabit": "Track First Habit",
    "getMoving": "Get Moving",
    "getMovingDesc": "No activity logged yet. Even 10 minutes of movement can boost your mood and energy.",
    "logActivity": "Log Activity",
    "allCaughtUp": "All Caught Up!",
    "allCaughtUpDesc": "You have no new notifications. Check back later for updates and wellness reminders.",
    "noResultsFound": "No Results Found",
    "noResultsFoundDesc": "We couldn't find any results for \"{query}\". Try adjusting your search or explore other options."
  },
  "footer": {
    "tagline": "Your AI-Powered Preventive Health Companion",
    "builtWith": "Built with care for your wellness journey",
    "allRightsReserved": "All rights reserved.",
    "about": "About",
    "privacy": "Privacy",
    "terms": "Terms",
    "contact": "Contact",
    "helpCenter": "Help Center"
  },
  "modals": {
    "feedback": {
      "title": "Share Your Feedback",
      "subtitle": "Help us improve HealthLoop",
      "whatWorking": "What's working well?",
      "whatImprove": "What could we improve?",
      "placeholder": "Share your thoughts...",
      "thankYou": "Thank you for your feedback!",
      "submitted": "Your feedback helps us make HealthLoop better."
    },
    "reportProblem": {
      "title": "Report a Problem",
      "subtitle": "Help us fix bugs and improve the app",
      "describe": "Describe the issue",
      "placeholder": "What happened? Please be as specific as possible...",
      "optional": "Optional: Steps to reproduce",
      "stepsPlaceholder": "1. I clicked on...\n2. Then I...",
      "thankYou": "Thank you for reporting!",
      "submitted": "We'll look into this right away."
    },
    "mealPreferences": {
      "title": "Customize Your Meals",
      "subtitle": "Tell us about your food preferences",
      "cuisines": "Preferred Cuisines",
      "selectCuisines": "Select all that apply",
      "dietary": "Dietary Preferences",
      "selectDietary": "Select your dietary needs",
      "allergies": "Allergies & Restrictions",
      "allergiesPlaceholder": "e.g., Nuts, Shellfish, Gluten",
      "save": "Save Preferences",
      "saving": "Saving..."
    },
    "upgrade": {
      "title": "Upgrade to Premium",
      "subtitle": "Unlock all features",
      "features": "Premium Features",
      "getStarted": "Get Started",
      "learnMore": "Learn More"
    }
  },
  "login": {
    "title": "Your Preventive Health Intelligence Platform",
    "subtitle": "Track, learn, and take action before problems escalate. Built for prevention, education, engagement, and wellness.",
    "email": "Email",
    "password": "Password",
    "signIn": "Sign In",
    "signingIn": "Signing in...",
    "forgotPassword": "Forgot Password?",
    "noAccount": "Don't have an account?",
    "createAccount": "Create one",
    "biometricLogin": "Sign in with Biometrics",
    "biometricHelper": "Use fingerprint, Face ID, or Windows Hello",
    "authenticating": "Authenticating...",
    "vendorPartner": "Are you a vendor partner?",
    "vendorLogin": "Vendor Login",
    "emailRequired": "Please enter your email first",
    "biometricSuccess": "Successfully signed in with biometrics! 🎉",
    "noPasskeys": "No biometric login set up. Please use password login first.",
    "biometricCancelled": "Biometric login cancelled",
    "biometricFailed": "Biometric login failed. Please try password login."
  },
  "register": {
    "title": "HealthLoop में शामिल हों",
    "subtitle": "अपनी निवारक स्वास्थ्य यात्रा आज शुरू करें",
    "fullName": "पूरा नाम",
    "email": "ईमेल",
    "password": "पासवर्ड",
    "confirmPassword": "पासवर्ड की पुष्टि करें",
    "createAccount": "खाता बनाएँ",
    "haveAccount": "पहले से खाता है?",
    "signIn": "साइन इन",
    "creating": "खाता बन रहा है...",
    "passwordTooShort": "पासवर्ड कम से कम 8 अक्षरों का होना चाहिए",
    "setupBiometric": "बायोमेट्रिक लॉगिन सेट करें",
    "setupBiometricDesc": "तेज़ और सुरक्षित लॉगिन के लिए फ़िंगरप्रिंट, Face ID या Windows Hello का उपयोग करें",
    "setupNow": "अभी सेट करें",
    "skipForNow": "अभी छोड़ें",
    "settingUp": "सेट हो रहा है...",
    "benefit1": "पासवर्ड याद रखने की ज़रूरत नहीं",
    "benefit2": "बायोमेट्रिक से अतिरिक्त सुरक्षा",
    "benefit3": "एक छुअन या नज़र से साइन इन",
    "biometricPrivacy": "आपका बायोमेट्रिक डेटा कभी डिवाइस से बाहर नहीं जाता",
    "biometricSuccess": "बायोमेट्रिक लॉगिन सेट हो गया! 🎉",
    "biometricFailed": "बायोमेट्रिक लॉगिन सेट नहीं हो सका। आप बाद में सेटिंग्स में सेट कर सकते हैं।",
    "biometricSetupLater": "आप बाद में अपनी प्रोफ़ाइल सेटिंग्स में बायोमेट्रिक लॉगिन सेट कर सकते हैं"
  },
  "womensHealthPage": {
    "title": "Women's Health Tracker",
    "subtitle": "Track your cycle, symptoms, and wellness",
    "cycleOverview": "Cycle Overview",
    "currentPhase": "Current Phase",
    "nextPeriod": "Next Period Expected",
    "logPeriod": "Log Period",
    "logSymptoms": "Log Symptoms",
    "insights": "Cycle Insights",
    "tips": "Phase-Based Tips",
    "history": "Period History",
    "noData": "No cycle data yet",
    "noDataDesc": "Start tracking your cycle to receive personalized insights and predictions.",
    "startTracking": "Start Tracking"
  },
  "notifications": {
    "title": "Notifications",
    "markAllRead": "Mark All as Read",
    "noNotifications": "No new notifications",
    "viewAll": "View All"
  },
  "familyHealth": {
    "title": "Family & Child Health",
    "subtitle": "Preventive health support for your entire family",
    "tabImmunizations": "Immunizations",
    "tabEducation": "Education",
    "tabReminders": "Reminders",
    "tabPlanner": "Family Planner",
    "immunizations": {
      "title": "Immunization Awareness",
      "subtitle": "Stay informed about recommended vaccines",
      "recommendedSchedule": "Recommended Schedule",
      "byAge": "By Age Group",
      "infants": "Infants (0-12 months)",
      "toddlers": "Toddlers (1-3 years)",
      "preschool": "Preschool (4-6 years)",
      "schoolAge": "School Age (7-12 years)",
      "teens": "Teens (13-18 years)",
      "adults": "Adults",
      "learnMore": "Learn More",
      "consultDoctor": "Always consult your healthcare provider for personalized vaccine recommendations",
      "upcomingReminders": "Upcoming Vaccine Reminders",
      "noReminders": "No upcoming vaccine reminders",
      "addReminder": "Add Vaccine Reminder",
      "reminderFor": "Reminder for",
      "dueDate": "Due Date",
      "notes": "Notes",
      "markComplete": "Mark Complete"
    },
    "education": {
      "title": "Family Health Education",
      "subtitle": "Evidence-based preventive health information",
      "categories": "Categories",
      "infant": "Infant Care",
      "child": "Child Development",
      "nutrition": "Nutrition & Growth",
      "safety": "Safety & Prevention",
      "mental": "Mental Wellness",
      "hygiene": "Hygiene & Habits",
      "searchPlaceholder": "Search health topics...",
      "popularTopics": "Popular Topics",
      "readMore": "Read More",
      "readTime": "min read"
    },
    "reminders": {
      "title": "Family Health Reminders",
      "subtitle": "Stay on track with preventive care for the whole family",
      "createReminder": "Create Reminder",
      "familyMember": "Family Member",
      "reminderType": "Reminder Type",
      "frequency": "Frequency",
      "activeReminders": "Active Reminders",
      "upcomingThisWeek": "Upcoming This Week",
      "noActiveReminders": "No active reminders",
      "types": {
        "checkup": "Health Checkup",
        "dental": "Dental Visit",
        "vision": "Vision Screening",
        "vaccine": "Vaccination",
        "medication": "Medication",
        "custom": "Custom"
      }
    },
    "planner": {
      "title": "Family Health Planner",
      "subtitle": "Coordinate preventive care for your family",
      "addMember": "Add Family Member",
      "memberName": "Member Name",
      "relationship": "Relationship",
      "dateOfBirth": "Date of Birth",
      "viewCalendar": "View Calendar",
      "upcomingCare": "Upcoming Preventive Care",
      "nothingScheduled": "Nothing scheduled yet",
      "scheduleCheckup": "Schedule Checkup",
      "relationships": {
        "child": "Child",
        "spouse": "Spouse",
        "parent": "Parent",
        "sibling": "Sibling",
        "other": "Other"
      }
    },
    "content": {
      "infantCare": {
        "title": "Infant Preventive Care",
        "intro": "Essential preventive health practices for your baby's first year",
        "topics": [
          "Well-baby checkup schedule",
          "Developmental milestones to watch",
          "Safe sleep practices",
          "Nutrition and feeding",
          "Immunization schedule"
        ]
      },
      "childDevelopment": {
        "title": "Child Development & Milestones",
        "intro": "Understanding healthy growth and development",
        "topics": [
          "Physical development milestones",
          "Social and emotional growth",
          "Language development",
          "Cognitive milestones",
          "When to talk to your doctor"
        ]
      },
      "nutrition": {
        "title": "Nutrition & Healthy Growth",
        "intro": "Building healthy eating habits from the start",
        "topics": [
          "Age-appropriate nutrition",
          "Healthy snack ideas",
          "Managing picky eaters",
          "Food safety basics",
          "Hydration guidelines"
        ]
      },
      "safety": {
        "title": "Safety & Injury Prevention",
        "intro": "Creating a safe environment for your family",
        "topics": [
          "Home safety checklist",
          "Car seat safety",
          "Water safety",
          "Poison prevention",
          "Emergency preparedness"
        ]
      }
    }
  }
};
